import { AlertColor } from '@mui/material';
import { ModalsState } from 'redux/slices/modals/modals.slice';
import { ZoomState } from 'redux/slices/zoom/zoom.slice';
import { AppState } from 'redux/slices/app/app.slice';
import { ReactNode } from 'react';

export interface MeetingConfig {
  sdkKey: string;
  sdkSecret: string;
  webEndpoint: string;
  topic: string;
  name: string;
  password: string;
  signature: string;
  sessionKey: string;
  userIdentity: string;
  role: number;
  cloud_recording_option: string;
  cloud_recording_election: string;
}

export interface NotifyState {
  open: boolean;
  message?: string;
  severity?: AlertColor;
}

export interface RootStateSchema {
  app: AppState;
  zoom: ZoomState;
  modals: ModalsState;
}

export enum EPageTypes {
  debate = 'debate',
  stream = 'stream',
}

export type TabData = {
  label: string;
  component: ReactNode | null;
  path?: string;
};
